<template>

  <main>

    <nav class="dots">
      <ul>
        <li v-for="(page, index) in pages">
            <v-touch tag="span"
              @click="clickDot(page.slug)"
              v-on:tap="clickDot(page.slug)"
              :key="page.slug"
              :href="'#'+page.slug"
              :title="page.title.rendered">
            </v-touch>

        </li>
      </ul>

    </nav>

    <section
      tag="section"
      v-for="(page, index) in pages"
      v-view="viewHandler"
      :class="'page '+page.slug"
      :name="page.slug"
      :id="page.slug"
      :key="page.id"
     >


        <div class="content" >
          <h1 v-view.once v-if="index === 0" ><span :data-text="page.title.rendered">{{page.title.rendered }}</span><br><span data-text="Porkies">Porkies</span></h1>
          <h2 v-view.once v-else ><span :data-text="page.title.rendered">{{page.title.rendered }}</span><br><span data-text="Porkies">Porkies</span></h2>
          <div class="body" v-view.once v-html=page.content.rendered  />
          <nav
            v-if="pages[index+1]"
            class="nextLink"
          >
            <v-touch tag="span"

              v-on:tap="clickDot(pages[index+1].slug)"
             >
             {{ pages[index+1].title.rendered }}
             <b></b>
            </v-touch>

          </nav>

        </div>

        <figure
          v-if="page._embedded['wp:featuredmedia']"
          v-for="image in page._embedded['wp:featuredmedia']"
          class="figure"
          :title="altTag(image)"
          :key="image.id"
          :style="{ backgroundImage: 'url(' + image.source_url + ')' }"
         >
          <img
            :src="image.source_url"
            :alt="altTag(image)">
        </figure>



    </section>


  </main>

</template>

<script>
import { mapState } from "vuex";
import  scrollIt from "@/js/scrollIt";
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();


export default {
  name: "Home",
  data () {
    return {
      index: 0,
      sections: [],
      nav: [],
      navBar: null,
      active: [],
      window: {},
      scrollListener: false,
      isScrolling: false,
      timer: null,
      touchstartX: 0,
      touchstartY: 0,
      touchendX:0,
      touchendY:0,
      touchStart:0,
      touchEnd:0,
      pushStateDelay: null
    }
  },
  computed: mapState(["pages", "pagesData"]),

  mounted() {
    var vm = this;
    vm.$store.dispatch("loadPages");

    let vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty('--vh', `${vh}px`);

    self.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    if(window.location.hash) {
      var hash = location.hash.substring(1)
      hash = document.getElementById( hash );
      if (hash){
        vm.index = Array.prototype.indexOf.call(vm.sections, hash);
        vm.changePage();
        vm.updateNav(vm.index);
      }
    }




  },
  updated(){
    var vm = this;
    vm.sections = document.querySelectorAll('section');
    vm.nav = document.querySelectorAll('.dots span');
    vm.navBar = document.querySelector('.dots');
    var dots = document.querySelector('.dots');

    vm.updateNav(vm.index);




    self.addEventListener('wheel', vm.scrollHandler, false);

    self.addEventListener('scroll', function ( event ) {

      vm.isScrolling = true;

      window.clearTimeout( vm.scrollListener );

      vm.scrollListener = setTimeout(function() {
        vm.isScrolling = false;
        // console.log('scrolling stopped')
        return false;
      }, 250);

    }, false);

    document.addEventListener('touchstart', function(e) {
      // console.log('touchstart')
        vm.touchstartX = e.changedTouches[0].screenX;
        vm.touchstartY = e.changedTouches[0].screenY;
        vm.touchStart = Date.now();
    }, false);

    document.addEventListener('touchend', vm.handleGesure, false);



  },
  watch: {
    index: function(val){
      var vm = this
      if(val < 0){
        val = 0;
        vm.index = val;
      }
      if(val >= vm.sections.length){
        val = vm.sections.length - 1;
        vm.index = val;
      }
    }
  },
  methods: {

    scrollBehaviour: function(){

    },

    handleGesure: function(e){
      var vm = this;
      var swiped = false;

      // console.log('touchend');

      vm.touchendX = e.changedTouches[0].screenX;
      vm.touchendY = e.changedTouches[0].screenY;
      vm.touchEnd = Date.now();


      if (
        Math.abs(vm.touchendX - vm.touchendY) > 25 &&
        Math.abs(vm.touchEnd - vm.touchStart) < 250
      ){
        swiped = true;
      }
      // if (vm.touchendY < vm.touchstartY && swiped) {
      //     vm.next()
      // }
      // if (vm.touchendY > vm.touchstartY  && swiped) {
      //     vm.prev()
      // }


    },

    wheelHandler: function(e){
      e.preventDefault();
    },

    scrollHandler: function(e){
      var vm = this;
      if(vm.index !== vm.sections.length - 1){
        e.preventDefault();
      }

      if (vm.isScrolling !== false) return;

      if(Math.abs(e.deltaY) > 10){
        self.removeEventListener('wheel', vm.scrollHandler, false);
        self.addEventListener('wheel', vm.wheelHandler, false);
        self.clearTimeout( vm.timer );
        vm.timer = setTimeout(function() {
          self.removeEventListener('wheel', vm.wheelHandler, false);
          self.addEventListener('wheel', vm.scrollHandler, false);
        }, 250);
      }

      if(vm.index !== vm.sections.length - 1){
        if(e.deltaY > 10){
          vm.index++;
          vm.changePage();
        }
      }
      if (e.deltaY < -1){
        e.preventDefault();
      }

      if ( e.deltaY < -10) {
         vm.index--;
         vm.changePage();
      }

    },
    getPages() {
      this.$store.dispatch("loadPages");
    },
    altTag(image) {
      return image.title.rendered || image.slug || image.id;
    },
    clickDot:function(slug){
      console.log(slug);
      var vm = this;
      var hash = document.getElementById( slug );
      if (hash){
        vm.index = Array.prototype.indexOf.call(vm.sections, hash);
        vm.changePage();
      }


    },
    updateNav: function(active){
      var vm = this;
      for (var i = vm.nav.length - 1; i >= 0; i--) {
        vm.nav[i].className = '';
      }
      vm.nav[active].className = 'active';
      vm.navBar.setAttribute('data-active', vm.index);

      clearTimeout(vm.pushStateDelay);
      vm.pushStateDelay = setTimeout(function() {
        history.pushState(null, null, '#'+vm.sections[active].id)
      }, 250);


    },
    changePage: function(event){
      var vm = this;
      var section = vm.sections[vm.index];

      if (typeof section !== 'undefined'){

        vm.scrollTarget = section.offsetTop;
        let offset = Math.abs(window.pageYOffset - vm.scrollTarget)/2.5;

        // window.scroll(0, vm.scrollTarget)

        // window.scrollTo({
        //   top: section.offsetTop,
        //   left: 0,
        //   behavior: 'smooth'
        // });

        scrollIt(vm.scrollTarget, offset, 'easeOutQuad', function(){
            // alert('done');
            window.scroll(0, vm.scrollTarget)
        })

        vm.updateNav(vm.index);

      }
    },
    prev: function(e){
      var vm = this;

      // console.log(e)

      if (vm.index > 0) {
        vm.index--;
        return vm.changePage()
      }
      return false
    },
    next: function(e){
      var vm = this;

      // console.log(e)

      if (vm.index < vm.sections.length -1 ) {
        vm.index++;
        return vm.changePage();
      }
      return false

    },
    parallaxHandler: function(event){
      return false;
      var vm = this;
      var targetElement =  event.target.element;
      var offset = Math.round(event.percentTop * (window.innerHeight/20) );
      offset = Math.max(offset, 0);

      var blurr = (1 - event.percentInView)*10;

      if (targetElement.nodeName === 'H1'){
        console.log(event)
      }


      if (targetElement.nodeName !== 'DIV'){

        targetElement.style.transform = 'translateY('+offset+'px)';
        targetElement.style.webkitTransform = 'translateY('+offset+'px)';
        targetElement.style.MozTransform = 'translateY('+offset+'px)';
        // targetElement.style.opacity = event.percentInView;
        // targetElement.style.filter = 'blur('+blurr+'px)';
      }


    },

    viewHandler: function(event){
      var vm = this;

      if (event.percentTop < 0.6 ){
        vm.index = Array.prototype.indexOf.call(vm.sections, event.target.element);
        vm.updateNav(vm.index);
      }

    }
  }
};
</script>

<style lang="scss">

// @import "@/scss/components/_pages.scss";

</style>
